<nz-skeleton [nzActive]="true" [nzLoading]="loader">
  <div *ngIf="!loader && newsView" class="max-sm:px-4">
    <!-- [routerLink]="['/noticias/', topNews[0].news_Bullet, topNews[0].newsUrl]" -->
    <!-- <div
      class="mb-5 aspect-news relative cursor-pointer flex flex-col justify-end bg-cover bg-center text-white rounded-8 p-12 max-sm:p-5 max-xl:p-8"
      [ngStyle]="{
        'background-image': 'url(' + newsView.news_Images[0] + ')'
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-40 rounded-8"></div>
      <div class="z-10 max-w-[700px]">
        <h1
          class="font-inter-700 text-26 max-sm:text-18 pb-5 max-sm:pb-2 hover:underline text-white"
        >
          {{ newsView.news_HeadLine }}
        </h1>
        <div class="flex gap-10 font-roboto-400 text-12">
          <span>{{ dateNews }}</span>
          <span>{{ newsView.news_Bullet }}</span>
        </div>
      </div>
    </div> -->

    <div
      class="mb-5 aspect-news relative cursor-pointer flex flex-col justify-end text-white rounded-8 p-12 max-sm:p-5 max-xl:p-8"
      [ngStyle]="{
        'background-image':
          'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(' +
          newsView.news_Images[0] +
          ')',
        'background-size': 'cover',
        'background-position': 'center'
      }"
    >
      <div class="max-w-[700px]">
        <h1
          class="font-inter-700 text-26 max-sm:text-18 pb-5 max-sm:pb-2 hover:underline text-white"
        >
          {{ newsView.news_HeadLine }}
        </h1>
        <div class="flex gap-10 font-roboto-400 text-12">
          <span>{{ dateNews }}</span>
          <span>{{ newsView.news_Bullet }}</span>
        </div>
      </div>
    </div>

    <div class="view-content text-justify">
      <div
        class="cursor-pointer font-roboto-800 italic pb-2"
        *ngIf="newsContentonTop"
        [routerLink]="['/']"
        [innerHTML]="newsContent.text"
      ></div>
      <div class="flex flex-col gap-4" [innerHTML]="newsView.news_Text"></div>
      <div
        class="cursor-pointer font-roboto-800 italic pt-2"
        *ngIf="!newsContentonTop"
        [routerLink]="['/']"
        [innerHTML]="newsContent.text"
      ></div>
    </div>

    <!-- Tags -->
    <div class="max-sm:side-padding">
      <div class="font-inter-700 text-24 max-sm:text-16 pt-9 pb-3">
        {{ "Tags" | translate }}
      </div>
      <div class="flex flex-wrap gap-2">
        <nz-tag
          nzColor="error"
          class="font-roboto-400 p-2 max-sm:text-12"
          *ngFor="let tag of tagsNews"
        >
          {{ tag }}
        </nz-tag>
      </div>
    </div>
  </div>
</nz-skeleton>

<nz-skeleton [nzActive]="true" [nzLoading]="loaderMoreNews"></nz-skeleton>

<div class="max-sm:px-4" *ngIf="!loaderMoreNews && arraysNotice.length > 0">
  <div
    class="font-inter-700 text-24 max-sm:text-16 pt-9 max-sm:pt-5 pb-3 max-sm:pb-1"
  >
    {{ "MoreNews" | translate }}
  </div>

  <div class="flex flex-col gap-7 max-sm:gap-4">
    <div
      class="flex gap-3 cursor-pointer max-[450px]:flex-col"
      [routerLink]="['/noticias/', notice.news_Bullet, notice.newsUrl]"
      *ngFor="let notice of this.arraysNotice | slice : 0 : 3"
    >
      <img
        alt="news-banner"
        class="max-w-[290px] h-[155px] max-sm:max-w-[190px] max-sm:h-[105px] max-[450px]:max-w-[unset] max-[450px]:h-[unset] max-[450px]:aspect-news w-full rounded-7 object-cover"
        [src]="notice.news_Images[0]"
      />
      <div class="font-inter-500 text-20 max-sm:text-14">
        {{ notice.news_HeadLine }}<br /><span
          class="font-sofia-sans-400 text-14 max-sm:text-11 text-grey-2"
          >{{
            notice?.match_date &&
              genericServices.getDisplayDate(notice.match_date, true)
          }}
          <span class="p-2"></span>
          {{ notice.news_Bullet }}</span
        >
      </div>
      <!-- <img alt="logo" class="ml-auto" [src]="urlIcon + 'save-active.svg'" /> -->
    </div>
  </div>
</div>
